import { __awaiter, __generator } from "tslib";
var AsyncEvaluation = (function () {
    function AsyncEvaluation(val) {
        this.val = val;
    }
    AsyncEvaluation.prototype.then = function (onfulfilled, onrejected) {
        return this.val.then(onfulfilled, onrejected);
    };
    AsyncEvaluation.evaluateTree = function (run) {
        var _this = this;
        return new AsyncEvaluation((function () { return __awaiter(_this, void 0, void 0, function () {
            var evaluation, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        evaluation = new Evaluation();
                        _a = evaluation;
                        return [4, run(evaluation)];
                    case 1:
                        _a.result = _b.sent();
                        return [2, evaluation];
                }
            });
        }); })());
    };
    Object.defineProperty(AsyncEvaluation.prototype, "isTruthy", {
        get: function () {
            var _this = this;
            return (function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.then(function (r) { return r.isTruthy; })];
                        case 1: return [2, _a.sent()];
                    }
                });
            }); })();
        },
        enumerable: false,
        configurable: true
    });
    AsyncEvaluation.prototype.throw = function (cb) {
        return new AsyncEvaluation(this.then(function (result) {
            return result.throw(cb);
        }));
    };
    AsyncEvaluation.prototype.throwError = function (klass) {
        return new AsyncEvaluation(this.then(function (result) {
            return result.throwError(klass);
        }));
    };
    return AsyncEvaluation;
}());
export { AsyncEvaluation };
var Evaluation = (function () {
    function Evaluation() {
        this.truthy = [];
        this.falsy = [];
    }
    Evaluation.evaluateTree = function (run) {
        var evaluation = new Evaluation();
        evaluation.result = run(evaluation);
        return evaluation;
    };
    Object.defineProperty(Evaluation.prototype, "isTruthy", {
        get: function () {
            if (this.result == null) {
                throw new TypeError("Designed: Evaluation result referenced before being evaluated");
            }
            return this.result;
        },
        enumerable: false,
        configurable: true
    });
    Evaluation.prototype.throwError = function (klass) {
        var _a, _b, _c;
        if (this.isTruthy) {
            return this;
        }
        var failed = this.falsy[0];
        var message = (_a = failed === null || failed === void 0 ? void 0 : failed.cause) === null || _a === void 0 ? void 0 : _a.message;
        var details = (_b = failed === null || failed === void 0 ? void 0 : failed.cause) === null || _b === void 0 ? void 0 : _b.details;
        throw klass.create(message, {
            details: {
                details: details,
                ruleClass: failed.rule.constructor,
                allFalsy: (_c = this.falsy.map(function (f) {
                    return {
                        type: f.rule.constructor,
                        details: f.cause.details,
                        message: f.cause.message
                    };
                })) !== null && _c !== void 0 ? _c : []
            }
        });
    };
    Evaluation.prototype.throw = function (cb) {
        if (this.isTruthy) {
            return this;
        }
        throw cb({
            lastFalsy: this.falsy[0],
            falsy: this.falsy,
            truthy: this.truthy
        });
    };
    Evaluation.prototype.evaluateRule = function (rule) {
        var result = rule.satisfied();
        if (result === true) {
            this.truthy.unshift(rule);
            return true;
        }
        if (typeof result === "string") {
            this.falsy.unshift({ rule: rule, cause: { details: {}, message: result } });
        }
        if (typeof result === "object") {
            this.falsy.unshift({ cause: result, rule: rule });
        }
        return false;
    };
    Evaluation.prototype.evaluateRuleAsync = function (rule) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, rule.satisfied()];
                    case 1:
                        result = _a.sent();
                        if (result === true) {
                            this.truthy.unshift(rule);
                            return [2, true];
                        }
                        if (typeof result === "string") {
                            this.falsy.unshift({ rule: rule, cause: { details: {}, message: result } });
                        }
                        if (typeof result === "object") {
                            this.falsy.unshift({ cause: result, rule: rule });
                        }
                        return [2, false];
                }
            });
        });
    };
    return Evaluation;
}());
export { Evaluation };
